import {BaseMobxStore} from "../../../../infrastructure/mobx/base-mobx-store";
import {EntityMegaHeaderModuleConfig} from "./entity-mega-header-module.config";
import {EntityMegaHeaderModuleState} from "./models/entity-mega-header-module.state";

export class EntityMegaHeaderModuleStore extends BaseMobxStore {
  static injectables = [EntityMegaHeaderModuleConfig, EntityMegaHeaderModuleState];
}

